import styled from "styled-components";
import { useState } from "react";
import { gql, useQuery, useMutation } from "@apollo/client";
import { captureException } from "@sentry/react";
import { useNavigate } from "react-router-dom";

import * as css from "styles/CssVariables.js";
import LoadingBox from "components/other/LoadingBox";
import BoxLoadingSpinner from "components/other/BoxLoadingSpinner";
import LeadList from "./LeadList";

const LeadListContainer = styled.div`
  margin-top: ${css.VERTICAL_BOX_MARGIN_MLARGE};
`;

export default ({ listId }) => {
  const navigate = useNavigate();

  const [page, setPage] = useState(1);
  const [filterMenuOpened, setFilterMenuOpened] = useState(false);
  const [verifiedFilter, setVerifiedFilter] = useState("all");

  const limit = 10;

  // Fetch data
  const GET_LEAD_LIST_DATA = gql`
    query GetLeadListData(
      $listId: ID!
      $verifiedFilter: String!
      $page: Int!
      $limit: Int!
    ) {
      leadListData(
        listId: $listId
        verifiedFilter: $verifiedFilter
        page: $page
        limit: $limit
      ) {
        leads {
          id
          created_at
          name
          email
          verified
          ip_address
          location_country
          page {
            name
            code
          }
        }
        numOfResults
      }
    }
  `;

  const { data, error } = useQuery(GET_LEAD_LIST_DATA, {
    variables: {
      listId,
      verifiedFilter,
      page,
      limit,
    },
    skip: !listId,
    fetchPolicy: "network-only",
  });

  if (error) {
    console.log("error fetching lead list data", error);
    captureException(error);
  }

  const openLead = (id) => {
    navigate(`/lead-detail?id=${id}&from=mailing-list&listId=${listId}`);
  };

  const paginate = (where) => {
    if (where === "previous") setPage((prevState) => prevState - 1);
    if (where === "next") setPage((prevState) => prevState + 1);
  };

  // Handle filter
  const onFilterMenuClick = () => {
    setFilterMenuOpened((prevState) => !prevState);
  };

  const closeFilterMenu = () => {
    setFilterMenuOpened(false);
  };

  const onFilterSelected = (option) => {
    setVerifiedFilter(option);
    setPage(1);

    localStorage.setItem("leads-status-filter", JSON.stringify(option));

    setFilterMenuOpened(false);
  };

  //console.log("data", data);

  return (
    <LeadListContainer>
      {!data && (
        <LoadingBox>
          <BoxLoadingSpinner height="300px" />
        </LoadingBox>
      )}
      {data && (
        <LeadList
          data={data}
          page={page}
          limit={limit}
          paginate={paginate}
          openLead={openLead}
          filterMenuOpened={filterMenuOpened}
          onFilterMenuClick={onFilterMenuClick}
          closeFilterMenu={closeFilterMenu}
          onFilterSelected={onFilterSelected}
          verifiedFilter={verifiedFilter}
        />
      )}
    </LeadListContainer>
  );
};
